import React from 'react'
import { Select } from '@ztechapps/webui.input'
import { serialNumberTypeOptions } from './serialNumberTypeOptions'

export const SerialNumberTypeSelect = ({ ...rest }) => {
  return (
    <Select
      isClearable={false}
      {...{
        ...rest,
        options: serialNumberTypeOptions,
      }}
    />
  )
}
